import { observable, computed, action, when } from "mobx";

class ErroreStore {

  constructor(rootStore) {
    this.rootStore = rootStore
    this.service = rootStore.service   
   
  }
  
  @observable error_code = ""
 
}

export default ErroreStore;